import IElDialog from './common/IElDialog';
import IElUploadFile from './common/IElUploadFile';
import IElSelect from './common/IElSelect';
import SvgIcon from './common/SvgIcon';
import IPagination from './common/IPagination';
import BOrganizationTree from './business/BOrganizationTree';
import BUploadExcel from './business/BUploadExcel';
import FileTable from './business/FileTable';
import PrintDialog from './business/PrintDialog';
import IEUploadFileType from './business/IEUploadFileType';
import IELUploadBtn from './common/IELUploadBtn';
import SiruiSearch from './SiruiSearch';
import SiruiTable from './SiruiTable';
import SearchTable from './form-item/search-table';
import InputNumberAd from './form-item/input-number-advance';
import InputNumber from '@/components/form-item/input-number';

const componentsMap = {
  IElDialog,
  IElSelect,
  IElUploadFile,
  SvgIcon,
  IPagination,
  BOrganizationTree,
  BUploadExcel,
  IELUploadBtn,
  SiruiSearch,
  SiruiTable,
  SearchTable,
  InputNumberAd,
  FileTable,
  InputNumber,
  IEUploadFileType,
  PrintDialog,
};
export default {
  install(app) {
    for (const key in componentsMap) {
      app.component(key, componentsMap[key]);
    }
  },
};
